import { DocumentationSourceIssue } from 'shared/domain/documentation/documentationModel';
import { IssueEntity } from '../issue/entity';

/**
 * Maps documentationId -> source issue metadata for files exported from issues.
 * If multiple issues point to the same documentation file, first match wins.
 */
export const createDocumentationSourceIssueMap = (
  issues: IssueEntity[]
): Map<string, DocumentationSourceIssue> => {
  const sourceIssueMap = new Map<string, DocumentationSourceIssue>();

  issues.forEach((issue) => {
    const issueId = String(issue._id ?? '').trim();
    const issueNumber = String(issue.issueNumberSearch ?? issue._id ?? '').trim();
    if (!issueId || !issueNumber) {
      return;
    }

    (issue.linkedDocumentation ?? []).forEach((linkedDoc) => {
      const hasSourceDocument = Boolean(linkedDoc.sourceDocumentId);
      const documentationId = String(linkedDoc.documentationId ?? '').trim();

      if (!hasSourceDocument || !documentationId) {
        return;
      }

      if (sourceIssueMap.has(documentationId)) {
        return;
      }

      sourceIssueMap.set(documentationId, {
        issueId,
        issueNumber,
      });
    });
  });

  return sourceIssueMap;
};
